"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComboBoxItemWrapper = exports.SelectedBar = exports.ListWrapper = exports.Wrapper = exports.ComboBoxButton = void 0;
/*
 * © 2025 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const styled_components_1 = __importDefault(require("../styled-components"));
const Button_1 = require("../Primitives/Button");
exports.ComboBoxButton = (0, styled_components_1.default)(Button_1.Button) `
  justify-content: space-between;
`;
exports.Wrapper = styled_components_1.default.div `
  flex: 1 1 100%;
  position: relative;
`;
exports.ListWrapper = styled_components_1.default.ul `
  z-index: 10;
  position: absolute;
  width: 100%;
  background: #333333;
  -webkit-overflow-scrolling: touch;
  max-height: 200px;
  margin: 0;
  padding: 0;
  overflow-y: auto;
`;
exports.SelectedBar = styled_components_1.default.div `
  background: ${(props) => props.selected ? props.theme.highlight : "rgba(255,255,255,0.05)"};
  width: 5px;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  z-index: 1;
`;
exports.ComboBoxItemWrapper = styled_components_1.default.li `
  position: relative;
  border: none;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  flex: 1;
  background: ${(props) => props.isSelected ? "#7dc2ff44" : "rgba(255, 255, 255, 0.05)"};

  padding: 5px;
  margin: 0;
  text-align: left;
  word-break: break-all;
  word-break: break-word;
  cursor: pointer;
  overflow: hidden;
  color: ${(props) => props.theme.fg};
  padding-left: 10px;
  outline-offset: -1px;

  &:hover {
    background: #7dc2ff44;
  }
`;
//# sourceMappingURL=style.js.map